import { styled } from "@mui/material";

import { Divider } from "@/Components/v2/atoms/Divider";
import { List } from "@/Components/v2/atoms/List";

interface DrawerFooterProps {
  children: React.ReactNode[];
}

const StyledDrawerFooter = styled("div")(() => ({
  marginTop: "auto",
}));

export const DrawerFooter: React.FC<DrawerFooterProps> = ({ children }) => {
  return (
    <StyledDrawerFooter>
      <Divider sx={{ marginTop: 2 }} />
      <List>{children}</List>
    </StyledDrawerFooter>
  );
};

export default DrawerFooter;
